<template>
  <div :class="weixinLoginIframeClasses">
    <div class="image skeleton" v-if="loading">
      <AppLoader />
    </div>
    <div class="content">
      <iframe
        :src="weixinConnectUrl"
        width="300"
        height="250"
        scrolling="no"
        frameBorder="0"
        allowTransparency="true"
        @load="onLoadIframe"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { queryStringProcess } from '@/app/app.service';
import {
  WEIXIN_WEBSITE_APP_ID,
  WEIXIN_LOGIN_REDIRECT_URI,
  WEIXIN_LOGIN_CUSTOM_STYLE,
} from '@/app/app.config';
import AppLoader from '@/app/components/app-loader';

export default defineComponent({
  name: 'WeixinLoginIframe',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      loading: true,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      socketId: 'user/socketId',
    }),

    weixinLoginIframeClasses() {
      return ['weixin-login-iframe', { loading: this.loading }];
    },

    weixinConnectUrl() {
      const baseUrl = 'https://open.weixin.qq.com/connect/qrconnect';

      const queryString = queryStringProcess({
        appid: WEIXIN_WEBSITE_APP_ID,
        redirect_uri: WEIXIN_LOGIN_REDIRECT_URI,
        response_type: 'code',
        scope: 'snsapi_login',
        login_type: 'jssdk',
        self_redirect: true,
        href: WEIXIN_LOGIN_CUSTOM_STYLE,
        state: this.socketId,
      });

      return `${baseUrl}?${queryString}`;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    onLoadIframe() {
      this.loading = false;
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppLoader,
  },
});
</script>

<style scoped>
@import './styles/weixin-login-iframe.css';
</style>
